import { useSlotsTrackerMetricsApi } from '@api/demo-slots/slots-tracker-metrics.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware( () => {
  void useSlotsTrackerMetricsApi()
})
